import React, { useState } from "react";
import akpol from ".././../assets/materi tni polri/AKPOL.webp";

const MateriAkpol = () => {
  // AKPOL
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [isDropdownPsikotes, setIsDropdownPsikotes] = useState(false);
  const [isDropdownJasmani, setIsDropdownJasmani] = useState(false);
  // AKPOL
  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible);
  };
  const toggleDropdownPsikotes = () => {
    setIsDropdownPsikotes(!isDropdownPsikotes);
  };
  const toggleDropdownJasmani = () => {
    setIsDropdownJasmani(!isDropdownJasmani);
  };

  const [openDropdown, setOpenDropdown] = useState(null);

  // Function to toggle the dropdown and close others
  const toggleDropdown2 = (dropdown) => {
    // If the clicked dropdown is already open, close it, else open it
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };
  return (
    <React.Fragment>
      <div className="container-materi">
        <h1 className="title-materi">
          Materi Akurat Lolos <br /> Akademi Kepolisian
        </h1>
        <div className="box-materi">
          {/* AKPOL */}
          <div className="child-card-materi-akpol">
            <div className="box-isi-materi">
              <h3
                className="dropdown-isi-materi"
                onClick={() => toggleDropdown2("akpol")}
              >
                Materi Akademik{" "}
                <span>{openDropdown === "akpol" ? "-" : "+"}</span>
              </h3>
              {openDropdown === "akpol" && (
                <ul className="dropdown-content">
                  <li>Tes Wawasan Kebangsaan</li>
                  <li>Tes Pengetahuan Umum</li>
                  <li>Bahasa Indonesia</li>
                  <li>Penalaran Numerik</li>
                  <li>Mental Ideologi</li>
                  <li>TOEFL</li>
                </ul>
              )}
              <h3
                className="dropdown-isi-materi"
                onClick={() => toggleDropdown2("psikotes")}
              >
                Psikotes <span>{openDropdown === "psikotes" ? "-" : "+"}</span>
              </h3>
              {openDropdown === "psikotes" && (
                <ul className="dropdown-content">
                  <li>Kecerdasan</li>
                  <li>Kecermatan</li>
                  <li>Kepribadian</li>
                </ul>
              )}
              <h3
                className="dropdown-isi-materi"
                onClick={() => toggleDropdown2("jasmani")}
              >
                Jasmani <span>{openDropdown === "jasmani" ? "-" : "+"}</span>
              </h3>
              {openDropdown === "jasmani" && (
                <ul className="dropdown-content">
                  <li>Jasmani A</li>
                  <li>Jasmani B</li>
                  <li>Jasmani C</li>
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default MateriAkpol;
